// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, A11y, Keyboard } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, A11y, Keyboard ]);

const relatedPropertiesSwiperArray = document.querySelectorAll('.swiper--related-properties')

if (relatedPropertiesSwiperArray) {

  relatedPropertiesSwiperArray.forEach((relatedPropertiesSwiper) => {
    // count number of slides to fix loop bug
    var slidesCount = relatedPropertiesSwiper.getElementsByClassName('swiper-slide').length;

// init Swiper:
    const swiper = new Swiper('.swiper--related-properties', {
      // Optional parameters
      loop: slidesCount > 1,
      slidesPerView: 1,
      watchSlidesProgress: true,
      spaceBetween: 20,
      watchOverflow: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      keyboard: {
        onlyInViewport: false
      },
      breakpoints : {
        501 : {
          slidesPerView: 2,
          loop: slidesCount > 2,
        },
        1024 : {
          slidesPerView: 3,
          loop: slidesCount > 3,
        },
        1280 : {
          slidesPerView: 4,
          loop: slidesCount > 4,
        }
      },

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next--related',
        prevEl: '.swiper-button-prev--related',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    });
  })

  buildHrefFromLocalStorage()
}

function buildHrefFromLocalStorage(){
  let anchor = document.querySelector('.archive-link a');
  if (anchor){
    if (anchor.dataset.blockJs === 'true') return false;
    let currentHref = anchor.href;
    let currentSection = currentHref.substring(currentHref.lastIndexOf('/') + 1)
    let storageSection = window.localStorage.getItem("lastMapSection")
    if (currentSection != storageSection)
      return false

    // lastMapSection
    let mapParams = JSON.parse(window.localStorage.getItem("mapParams"));
    if (mapParams === null)
      return false;

    let baseUrl =  window.location.origin + '/' + currentSection;
    const url = new URL(baseUrl);
    if (!!mapParams[currentSection]){
      url.search = new URLSearchParams(mapParams[currentSection]);
      anchor.href = url
    }
  }
}

